import React from 'react';

import { Text } from '@reckon-web/text';

import { NamedUserAvatar } from '../../../common/named-user-avatar';
import { useGetUser } from '../../../../data/useGetUser';

// TODO move this somewhere shared
type AvatarHelperType = {
  initiatedBy_user_cloudId: string;
  initiatedBy_user_name: string; //TODO make this optional
  testId?: string;
};

export const AvatarHelper = ({
  initiatedBy_user_cloudId,
  initiatedBy_user_name,
  testId,
}: AvatarHelperType): React.ReactElement => {
  const { data, loading } = useGetUser({
    variables: { cloudId: initiatedBy_user_cloudId },
  });

  // TODO: handle loading, and make sure it has the same height as the xsmall avatar if has data
  if (loading) return <Text>{initiatedBy_user_name}</Text>;

  return !data ? (
    <Text size="small" weight="medium">
      (Unknown user)
    </Text>
  ) : (
    <NamedUserAvatar
      user={data}
      avatarSize="xsmall"
      textSize="small"
      data-testid={testId}
    />
  );
};
